/**
 * The one nav entry the app list contributes.
 *
 * Note what is NOT here: no nav entry anywhere is gated on whether its app is
 * installed. The menu stays the whole product, and a section the company has
 * not turned on explains itself when opened rather than disappearing.
 */
import { LayoutGrid } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const appsNavEntries: NavEntry[] = [
  {
    path: "/admin/apps",
    labelKey: "apps.title",
    icon: LayoutGrid,
    permission: "platform.module.read",
  },
];
